import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';
import OcurrencesWrapper from './Ocurrences';
import PeriodWrapper from './Period';
import ProfileWrapper from './Profile';
import SectorizationWrapper from './Sectorization';
import SpecialCareWrapper from './SpecialCare';

const titleMap = {
    0: 'Ocorrências',
    1: 'Periodicidade',
    2: 'Perfil',
    3: 'Setorização',
    4: 'Cuidados Especiais'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return <OcurrencesWrapper />;
        case 1:
            return <PeriodWrapper />;
        case 2:
            return <ProfileWrapper />;
        case 3:
            return <SectorizationWrapper />;
        case 4:
            return <SpecialCareWrapper />;
        default:
            return null;
    }
};

export const Results = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Ocorrências',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Periodicidade',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'Perfil',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        },
        {
            title: 'Setorização',
            onclick: () => setActiveIndexLocal(3),
            active: activeIndexLocal === 3
        },
        {
            title: 'Cuidados Especiais',
            onclick: () => setActiveIndexLocal(4),
            active: activeIndexLocal === 4
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box>
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};